import { TimeOffSideNavComponent } from './time-off-side-nav/time-off-side-nav.component';

export const StandaloneComponents = [TimeOffSideNavComponent];

export { TimeOffSideNavComponent };
